import React from 'react';
import { BODEGA_DEFAULTS } from '../../constants';
import PrivacyPolicyLink from './PrivacyPolicyLink';

/**
 * Cookie checkboxes to use in our expanded modal.
 * @type {Array<Object>}
 */
const cookieChecks = [
  {
    name: 'functional',
    readOnly: true,
    label: {
      id: 'nav_cookie_label_functional',
      defaultMessage: BODEGA_DEFAULTS.COOKIE_MODAL_CHECK_FUNCTIONAL_LABEL,
    },
    body: {
      id: 'nav_cookie_text_functional',
      defaultMessage: BODEGA_DEFAULTS.COOKIE_MODAL_CHECK_FUNCTIONAL_BODY,
    },
  },
  {
    name: 'allowPerformance',
    label: {
      id: 'nav_cookie_label_performance',
      defaultMessage: BODEGA_DEFAULTS.COOKIE_MODAL_CHECK_PERFORMANCE_LABEL,
    },
    body: {
      id: 'nav_cookie_text_performance',
      defaultMessage: BODEGA_DEFAULTS.COOKIE_MODAL_CHECK_PERFORMANCE_BODY,
    },
  },
  {
    name: 'allowMarketing',
    label: {
      id: 'nav_cookie_label_socialMedia',
      defaultMessage: BODEGA_DEFAULTS.COOKIE_MODAL_CHECK_SOCIAL_AND_ADVERTISING_LABEL,
    },
    body: {
      id: 'nav_cookie_text_socialMedia_2',
      defaultMessage: BODEGA_DEFAULTS.COOKIE_MODAL_CHECK_SOCIAL_AND_ADVERTISING_BODY,
      templateValues: {
        privacyAndCookiePolicyHTML: (
          <PrivacyPolicyLink key="allow-marketing-checkbox-privacy-policy-link" />
        ),
      },
    },
  },
];

export default cookieChecks;
